import { SPREAD_SCORE_INFO_REQUEST_INPUT_SCORE_RANGES } from '@app.feature/exam/gsat2024-2/constants/stepFive.constant'

type FindTooltipPositionFn = (score: number) => number

type FindScorePositionParams = {
  myScore: number
  averageScore: number
  smaeInfoAverageScore: number
}

type FindScorePositionFn = (params: FindScorePositionParams) => {
  myScoreIndex: number
  averageScoreIndex: number
  sameInfoAverageScoreIndex: number
}

/**
 * @description 현재 위치값에 따라 툴팁 위치값을 찾는 함수
 * @param score 현재 위치값
 * @returns
 */
export const findTooltipPosition: FindTooltipPositionFn = (score) => {
  return SPREAD_SCORE_INFO_REQUEST_INPUT_SCORE_RANGES.findIndex((range) => {
    if (range.to !== undefined) {
      return score >= range.from && score <= range.to
    }
    return score >= range.from
  })
}

export const findScrorePosition: FindScorePositionFn = ({
  myScore,
  averageScore,
  smaeInfoAverageScore,
}) => {
  const myScoreIndex = findTooltipPosition(myScore)

  const averageScoreIndex = findTooltipPosition(averageScore)

  const sameInfoAverageScoreIndex = findTooltipPosition(smaeInfoAverageScore)

  return {
    myScoreIndex,
    averageScoreIndex,
    sameInfoAverageScoreIndex,
  }
}
